import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

export default function LegalPage({ kind = "terms" }) {
  const { t, i18n } = useTranslation();
  const title = kind === "terms" ? t("legal.termsTitle") : t("legal.privacyTitle");
  const lang = i18n.language || "en";
  const dateStr = new Date().toLocaleDateString(lang, { year: "numeric", month: "long", day: "numeric" });

  const keys = Array.from({ length: 9 }, (_, i) => i + 1);

  return (
    <div data-testid={`${kind}-page`} className="px-6 md:px-10 lg:px-16 py-12 md:py-16 max-w-3xl">
      <Link to="/" className="text-sm text-zinc-500 hover:text-zinc-950 inline-block mb-8">← {t("legal.back")}</Link>
      <div className="overline mb-3">{t("legal.breadcrumb", { title })}</div>
      <h1 className="font-display font-black text-5xl tracking-[-0.04em] leading-none mb-3">{title}</h1>
      <div className="text-xs text-zinc-500 font-mono mb-12">{t("legal.lastUpdated", { date: dateStr })}</div>

      <div className="space-y-8 leading-relaxed text-zinc-700">
        {keys.map((n) => (
          <Section
            key={n}
            h={t(`legal.${kind}.s${n}h`)}
            i18nKey={`legal.${kind}.s${n}b`}
            year={new Date().getFullYear()}
          />
        ))}
      </div>
    </div>
  );
}

function Section({ h, i18nKey, year }) {
  return (
    <section>
      <h2 className="font-display font-semibold text-xl tracking-tight mb-2">{h}</h2>
      <div className="text-base">
        <Trans
          i18nKey={i18nKey}
          values={{ year }}
          components={{
            strong: <strong />,
            em: <em />,
            br: <br />,
            a: <a href="mailto:hello@conferencely.org" className="underline" />,
          }}
        />
      </div>
    </section>
  );
}
